const HangingClockIcon = /*#__PURE__*/ [
  ["circle", { cx: "17.5", cy: "4.5", r: "1.5", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "17.5", cy: "15.5", r: "4.5", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2 8H20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "bevel", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M17.5 6V11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "bevel", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M2 6V21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "bevel", strokeWidth: "1.5", key: "4" }],
  ["path", { d: "M2 20C2 13.3726 7.37258 8 14 8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "bevel", strokeWidth: "1.5", key: "5" }],
  ["path", { d: "M18.5 16.5L17.5 16V14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "6" }]
];

export { HangingClockIcon as default };
//# sourceMappingURL=HangingClockIcon.js.map
